import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Modal from "../components/Modal";
import {
    getActionAuthentication,
    getConfig, getSpaceQrModalVisibility,
    setActionAuthentication, setSpaceQrModalVisibility,
} from "../reducers/configSlice";
import QRCode from "react-native-qrcode-svg";
import {StyleSheet, View} from "react-native";
import * as functions from "../services/helpers/dateTimeHelpers";


import {actuatedWithoutScale} from "../services/helpers/stylingHelpers";

const SpaceQrModal = () => {
    const dispatch = useDispatch()
    const spaceQrModalVisible = useSelector(getSpaceQrModalVisibility)
    const config = useSelector(getConfig)

    const getQrValue = () => {
        if (!config.space_qr_code) {
            return '';
        }

        if (typeof config.space_qr_code === 'string' || config.space_qr_code instanceof String) {
            return config.space_qr_code;
        }

        return JSON.stringify(config.space_qr_code);
    }

    return (
        <Modal visible={spaceQrModalVisible && config.space_qr_code}
               onClose={() => {dispatch(setSpaceQrModalVisibility(!spaceQrModalVisible))}}
               title={translate("Quick book")}
               subtitle={translate("Scan this QR code from the YAROOMS app to instantly book the room on your YAROOMS account")}
               disabled={false}
               buttonText={translate("Dismiss").toUpperCase()}
               onButtonPress={() => {dispatch(setSpaceQrModalVisibility(!spaceQrModalVisible))}}
        >
            <View style={styles.qrWrapper}>
                {
                    spaceQrModalVisible && config.space_qr_code ?
                        <QRCode
                            value={getQrValue()}
                            size={actuatedWithoutScale(250)}
                            quietZone={10}
                        /> : null
                }
            </View>
        </Modal>
    )
}

export default SpaceQrModal

const styles = StyleSheet.create({
    qrWrapper: {
        flex: 0.6,
        justifyContent: 'center',
        alignItems: 'center'
    },
});

